// extracted by mini-css-extract-plugin
module.exports = {"header":"QjrUh","logo":"YzQ+c","tableInfo":"B74Xh","tableInfo-number":"x+J48","tableInfo-body":"AsOUt","tableInfo-edit":"UPV3v"};